import React, { useId } from 'react';
import { useBranding } from '../BrandingContext';
import './FullPageState.css';

function FullPageState({
  icon,
  eyebrow = 'EXREG',
  statusLabel,
  title,
  description,
  supportingText,
  actions,
  fullViewport = false,
  role = 'status',
  ariaLive = 'polite',
}) {
  const { isBranded, brand } = useBranding();
  const instanceId = useId();
  const titleId = `full-page-state-title-${instanceId}`;
  const descriptionId = `full-page-state-description-${instanceId}`;
  const supportingTextId = supportingText
    ? `full-page-state-supporting-${instanceId}`
    : undefined;
  const describedBy = [descriptionId, supportingTextId].filter(Boolean).join(' ');

  return (
    <div
      className={`full-page-state${fullViewport ? ' full-page-state--viewport' : ''}`}
    >
      <section
        className="full-page-state__panel"
        role={role}
        aria-live={ariaLive}
        aria-labelledby={titleId}
        aria-describedby={describedBy}
      >
        <div className="full-page-state__brand" aria-label={isBranded ? `${brand.name}, powered by EXREG` : 'EXREG'}>
          <span className="full-page-state__brand-mark" aria-hidden="true" />
          <span>{isBranded ? `${brand.name} · EXREG` : 'EXREG'}</span>
        </div>

        <div className="full-page-state__content">
          {icon && (
            <div className="full-page-state__icon" aria-hidden="true">
              {icon}
            </div>
          )}

          <div className="full-page-state__meta">
            <span className="full-page-state__eyebrow">{isBranded && eyebrow === 'EXREG' ? brand.name : eyebrow}</span>
            {statusLabel && (
              <span className="full-page-state__status">{statusLabel}</span>
            )}
          </div>

          <h1 id={titleId} className="full-page-state__title">
            {title}
          </h1>
          <p id={descriptionId} className="full-page-state__description">
            {description}
          </p>

          {supportingText && (
            <p id={supportingTextId} className="full-page-state__supporting-text">
              {supportingText}
            </p>
          )}

          {actions && <div className="full-page-state__actions">{actions}</div>}
        </div>
      </section>
    </div>
  );
}

export default FullPageState;
